export const cilWallpaper = ["24 24","<path d='M16.125 5.25h1.875v1.875h-1.875v-1.875z'></path><path d='M3.375 3.375h7.125v-1.5h-8.625v8.625h1.5v-7.125z'></path><path d='M13.5 1.875v1.5h7.125v7.125h1.5v-8.625h-8.625z'></path><path d='M3.375 13.5h-1.5v8.625h8.625v-1.5h-7.125v-7.125z'></path><path d='M13.148 14.478l-4.266-4.266-4.008 4.008v2.121l4.008-4.008 6.791 6.791h2.121l-3.586-3.586 3.38-3.38 3.036 3.036v5.43h-7.125v1.5h8.625v-7.5l-4.536-4.587-4.441 4.44z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-wallpaper.js
// module id = null
// module chunks = 